import React from 'react'
import { Hero, Container, Content } from 'react-bulma-components'
import { StyledHeading } from '../../utils/commonStyles'
import { StaticImage } from 'gatsby-plugin-image'
import { useTranslation } from 'gatsby-plugin-react-i18next'

export const NepovratnaSredstva = () => {
    const { t } = useTranslation()
    return (
        <Hero>
            <Hero.Body>
                <Container>
                    <Content>
                        <StyledHeading className={'has-text-centered'} size={3}>
                            {t('onas.tourism.title')}
                        </StyledHeading>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: t('onas.tourism.description'),
                            }}
                        ></p>
                        <StaticImage
                            src="../../images/program-razvoja-podezelja.png"
                            alt="Program razvoja podeželja Logotip"
                            height={60}
                        />
                    </Content>
                </Container>
            </Hero.Body>
        </Hero>
    )
}

export default NepovratnaSredstva
